export const QUIZ_TYPE = {
  FULL_SYSTEM: "Full System",
  JUST_CAMERAS: "Just Cameras",
} as const;

export function resolveQuizTypeFromStartKey(startQuestionKey?: string): string {
  if (startQuestionKey === "camera-types") return QUIZ_TYPE.JUST_CAMERAS;
  if (startQuestionKey === "protection-types") return QUIZ_TYPE.FULL_SYSTEM;
  return "";
}

export function resolveQuizTypeFromAnswer(answer?: unknown): string {
  if (typeof answer !== "string") return "";

  const lower = answer.toLowerCase();
  if (lower.includes("camera")) return QUIZ_TYPE.JUST_CAMERAS;
  if (
    lower.includes("full") ||
    lower.includes("system") ||
    lower.includes("smart home")
  ) {
    return QUIZ_TYPE.FULL_SYSTEM;
  }

  return "";
}

export function resolveQuizType({
  answer,
  startQuestionKey,
}: {
  answer?: unknown;
  startQuestionKey?: string;
}): string {
  return (
    resolveQuizTypeFromStartKey(startQuestionKey) ||
    resolveQuizTypeFromAnswer(answer)
  );
}
